// 声网
import AgoraRTM from 'agora-rtm-sdk';
import EventEmitter from 'events';

class RTMClient extends EventEmitter {
  // 私有属性
  constructor() {
    super();
    this.channels = {};
    this._logined = false;
  }
  // 初始化
  init(appid){
    this.client = AgoraRTM.createInstance(appid);
    this.subscribeClientEvents();
  }
  // 监听事件
  subscribeClientEvents (){
    const clientEvents = [
      "ConnectionStateChanged",
      "MessageFromPeer",
    ];
    clientEvents.forEach((eventName) => {
      this.client.on(eventName, (...args) => {
        // console.log("emit ", eventName, ...args);
        this.emit(eventName, ...args);
      });
    });
  }
  // 监听事件
  subscribeChannelEvents(channelName) {
    const channelEvents = [
      "ChannelMessage",
      "MemberJoined",
      "MemberLeft"
    ];
    channelEvents.forEach((eventName) => {
      this.channels[channelName].channel.on(eventName, (...args) => {
        // console.log("emit ", eventName, args);
        this.emit(eventName, {channelName, args: args});
      });
    });
  }
  // 登录
  async login(accountName, token) {
    this.accountName = accountName;
    return this.client.login({ token: token, uid: this.accountName });
  }
  // 登出
  async logout() {
    return this.client.logout();
  }
  // 加入频道
  async joinChannel(name) {
    // console.log("joinChannel", name)
    const channel = this.client.createChannel(name);
    this.channels[name] = {
      channel,
      joined: true // channel state
    }
    this.subscribeChannelEvents(name)
    return channel.join();
  }
  // 离开频道
  async leaveChannel(name) {
    // console.log("leaveChannel", name);
    if (!this.channels[name] ||
      (this.channels[name]
        && !this.channels[name].joined)) return;
    return this.channels[name].channel.leave();
  }
  // 发送频道信息
  async sendChannelMessage(text, channelName) {
    // console.log("sendChannelMessage", text, channelName);
    if (!this.channels[channelName] || !this.channels[channelName].joined) return;
    return this.channels[channelName].channel.sendMessage({text});
  }
  // 发送点对点消息
  // async sendPeerMessage(text, peerId) {
  //   console.log("sendPeerMessage", text, peerId);
  //   return this.client.sendMessageToPeer({text}, peerId.toString());
  // }
  // 查询用户在线状态
  // async queryPeersOnlineStatus(memberId) {
  //   console.log("queryPeersOnlineStatus", memberId);
  //   return this.client.queryPeersOnlineStatus([memberId]);
  // }
}
export default  RTMClient;